export default function SharePopupModule(element) {

    let qs = element.querySelector.bind(element);
    let qsa = element.querySelectorAll.bind(element);
    let $title = qs('.sharepopup__thing__text');
    let $image = qs('.sharepopup__thing__image');

    let $wrapper = qs('.sharepopup__wrapper');

    this.show = function(url, title, imageSrc) {
        setValues(url, title, imageSrc);
        animateShow();
    }

    function setValues(url, title, imageSrc) {
        $title.innerText = title;

        if (imageSrc) {
            $image.src = imageSrc;
            $image.style.display = 'block';
        } else {
            $image.style.display = 'none';
        }

        qsa('.sharepopup__option').forEach(function($option) {
            $option.setAttribute('data-href', url);
        });
    }

    function animateShow() {
        element.style.display = 'flex';
        $wrapper.animate(
            [
                { transform: 'translateY(50px)', opacity: 0},
                { transform: 'translateY(0px)', opacity: 1},
            ],
            { duration: 300, }
        );
    }

    function hide() {
        element.style.display = 'none';
    }

    function bindEvents() {
        qs('.sharepopup__close').addEventListener('click', function(event) {
            event.stopPropagation();
            event.preventDefault();
            hide();
        });
        document.addEventListener('keyup', function(event) {
            if (event.key === 'Escape') {
                hide();
            }
        });
    }


    bindEvents();
    

    return this;
}